import { FC } from "react";

interface FaqSvgProps {}

const FaqSvg: FC<FaqSvgProps> = (): JSX.Element => {
	return (
		<svg
			width="366"
			height="200"
			viewBox="0 0 366 200"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_265_637)">
				<path
					d="M35.6699 199.277V113.71C35.6757 104.828 39.2081 96.3119 45.4906 90.0334C51.7732 83.7549 60.2917 80.228 69.1737 80.228H95.4125"
					stroke="#032B6B"
					strokeWidth="1.44527"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M133.205 124.646C133.205 124.646 136.064 133.209 136.483 137.354M168.402 121.546C168.146 126.936 168.235 132.337 168.67 137.716"
					stroke="#032B6B"
					strokeWidth="1.92703"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M195.318 94.3506C196.316 95.3791 196.701 109.615 205.71 109.446"
					stroke="#032B6B"
					strokeWidth="1.44527"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M97.956 98.7322C94.0104 100.474 88.3208 103.858 83.7441 110.868C90.1949 108.218 112.392 128.066 128.126 123.564C120.81 122.789 105.134 111.301 97.956 98.7322Z"
					fill="#032B6B"
				/>
				<path
					d="M110.775 67.064C91.6825 76.1523 91.42 88.9261 97.9092 100.033C94.5032 100.57 86.2604 105.212 68.816 129.844C43.702 165.304 44.9064 198.391 93.7565 199.234M187.104 145.952V145.812C244.657 151.282 242.988 126.212 236.966 101.009L221.848 51.0215C219.62 46.1606 217.628 48.2418 216.79 46.7218C214.851 43.1713 214.08 41.6128 214.08 41.6128C207.008 47.6034 192.883 44.9851 192.883 44.9851C192.883 44.9851 192.762 46.2786 192.664 50.2338C192.565 54.189 188.159 53.6061 188.677 58.8621L195.301 94.3483L176.896 90.4244C175.718 83.9809 172.716 74.2036 165.5 68.0227M189.792 199.106L189.494 178.501"
					stroke="#032B6B"
					strokeWidth="1.44527"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M185.498 92.2575C182.593 91.0531 178.717 90.6026 176.181 90.1956C176.659 92.6107 176.869 95.0714 176.807 97.5327C176.261 110.222 171.296 115.175 170.113 119.848C185.373 114.223 186.563 99.3417 185.498 92.2575Z"
					fill="#032B6B"
				/>
				<path
					d="M162.626 166.431C162.305 169.115 161.689 170.242 155.411 173.47C153.809 174.294 150.435 176.081 145.913 178.348C146.85 189.931 147.359 198.451 147.359 198.451L166.174 198.714C166.174 198.714 165.653 179.35 165.246 159.677C164.203 161.787 162.818 164.798 162.626 166.431ZM164.825 121.659C165.066 111.28 161.091 101.098 157.249 94.2858C156.628 103.762 154.599 114.746 152.456 118.328C142.339 111.311 134.751 107.288 128.686 104.085C124.853 97.9062 121.618 92.3973 120.221 88.4012L120.279 86.5657L119.619 86.6307C121.305 92.1878 124.943 100.089 132.472 110.702C134.011 112.496 135.42 114.398 136.69 116.391C138.487 119.207 140.135 127.173 141.568 137.107C149.943 135.943 156.433 135.714 157.61 137.499L164.887 138.892C164.618 125.017 164.697 127.325 164.825 121.659Z"
					fill="#FFA108"
				/>
				<path
					d="M174.513 156.777L163.319 159.068M187.795 172.851C188.734 176.464 190.811 183.415 192.372 183.319C194.588 183.182 193.403 169.305 193.094 165.046C192.942 162.861 191.408 155.833 190.156 152.28C188.52 147.631 181.065 133.474 165.904 138.639L154.951 141.32"
					stroke="#032B6B"
					strokeWidth="1.44527"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M175.117 153.954C174.876 156.418 173.431 161.599 175.317 165.003M189.792 164.776C189.792 164.776 188.609 174.84 185.246 175.616C181.884 176.391 181.669 173.554 181.669 173.554"
					stroke="#032B6B"
					strokeWidth="1.44527"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M185.758 164.432C185.758 164.432 183.942 173.303 180.528 173.826C177.115 174.349 177.115 171.521 177.115 171.521"
					stroke="#032B6B"
					strokeWidth="1.44527"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M180.778 163.885C180.778 163.885 178.42 174.52 174.633 170.487C170.847 166.455 171.247 164.4 171.247 164.4C171.247 164.4 173.068 161.479 175.987 166.144"
					stroke="#032B6B"
					strokeWidth="1.44527"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M162.778 164.738C154.263 157.829 151.375 140.431 154.973 136.623C155.118 135.418 157.883 137.454 159.55 137.639C163.573 138.087 165.307 138.21 165.307 138.21C163.676 143.225 165.492 149.29 167.359 153.604C168.16 155.511 169.087 157.362 170.134 159.145C169.814 159.306 168.52 159.944 165.444 161.293C163.671 162.081 163.296 163.411 162.778 164.738Z"
					fill="#032B6B"
				/>
				<path
					d="M95.4109 138.612C99.171 137.367 109.295 135.642 112.383 142.772M95.4109 146.768C95.4109 146.768 153.836 131.762 157.613 137.49L166.484 157.326C166.484 157.326 162.944 163.745 162.63 166.431C162.317 169.117 161.693 170.242 155.416 173.47C149.139 176.697 116.343 195.537 92.8359 199.234"
					stroke="#032B6B"
					strokeWidth="1.44527"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M120.66 74.9768C120.533 78.7345 120.364 83.8219 120.222 88.3962C121.619 92.3923 124.854 97.9012 128.686 104.08C134.752 107.283 142.332 111.306 152.456 118.323C154.624 114.741 156.628 103.757 157.25 94.2808M117.577 57.3446C115.763 57.5059 108.975 58.5899 110.413 65.7753C111.555 71.4913 116.78 70.9831 119.909 70.1111M165.379 43.8843C166.666 53.6952 166.071 64.2264 165.064 72.067"
					stroke="#032B6B"
					strokeWidth="1.44527"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M165.063 72.0574C164.642 75.3574 164.146 78.1781 163.686 80.2617"
					stroke="#032B6B"
					strokeWidth="1.44527"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M122.918 59.062C124.438 60.5988 128.513 69.4583 129.508 73.5894C129.508 73.5894 139.594 70.1183 154.044 69.9063C154.044 69.9063 161.923 70.0677 165.064 71.0216C165.064 71.0216 164.385 85.6501 157.997 93.2258C151.609 100.801 138.103 98.6817 131.76 94.1267C125.418 89.5716 124.378 87.3989 122.911 82.526C121.444 77.653 117.57 59.486 117.57 59.486L122.918 59.062Z"
					stroke="#032B6B"
					strokeWidth="1.44527"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M150.066 82.5548C150.066 82.5548 154.005 81.772 155.607 83.3377L150.066 82.5548Z"
					fill="white"
				/>
				<path
					d="M150.066 82.5548C150.066 82.5548 154.005 81.772 155.607 83.3377"
					stroke="#032B6B"
					strokeWidth="1.44527"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M155.087 64.2747L156.551 77.0195L152.057 75.8705"
					stroke="#032B6B"
					strokeWidth="1.44527"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M159.79 67.7216C160.511 67.7216 161.095 66.8168 161.095 65.7007C161.095 64.5845 160.511 63.6797 159.79 63.6797C159.069 63.6797 158.484 64.5845 158.484 65.7007C158.484 66.8168 159.069 67.7216 159.79 67.7216Z"
					fill="#032B6B"
				/>
				<path
					d="M147.22 67.4999C147.941 67.4999 148.525 66.5951 148.525 65.479C148.525 64.3628 147.941 63.458 147.22 63.458C146.499 63.458 145.914 64.3628 145.914 65.479C145.914 66.5951 146.499 67.4999 147.22 67.4999Z"
					fill="#032B6B"
				/>
				<path
					d="M141.557 54.9359C142.216 54.0915 143.089 53.4394 144.086 53.0475C145.083 52.6556 146.167 52.5383 147.225 52.7078"
					stroke="#032B6B"
					strokeWidth="1.44527"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M159.221 52.4861C159.221 52.4861 162.834 51.5467 163.747 54.5071"
					stroke="#032B6B"
					strokeWidth="1.44527"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M173.673 41.8177C173.355 40.8879 173.716 39.7558 174.381 38.6164L174.208 38.4213L173.391 40.7096C173.391 40.7096 170.836 41.8104 169.992 38.5417C169.732 37.5421 170.322 36.3232 171.262 35.1164L171.235 35.0851C167.682 35.9089 160.74 37.253 160.114 35.8559C159.23 33.8783 171.756 28.6296 175.571 26.9434C177.527 26.0883 184.296 24.2311 187.943 23.7012C190.362 23.3936 192.809 23.3669 195.234 23.6217C195.516 21.3803 195.079 19.1073 193.986 17.1301C192.804 14.9477 190.332 11.7031 188.138 10.5396C166.389 -0.996028 155.778 18.4886 155.778 18.4886C155.778 18.4886 152.717 10.1325 142.807 9.83386C140.797 9.77973 138.797 10.1363 136.929 10.8819C135.062 11.6274 133.366 12.7461 131.946 14.1697C123.831 22.3041 129.241 31.5129 129.241 31.5129C129.241 31.5129 125.461 29.5859 120.364 32.0452C114.275 34.9912 111.211 41.8875 112.794 48.4659C114.48 55.4514 117.577 62.102 117.577 62.102C137.368 65.166 142.426 45.7343 139.512 43.2268C143.901 46.4738 151.797 48.649 165.17 47.3049C168.232 46.9869 171.987 45.7825 175.81 43.9567C175.07 43.8555 174.21 43.3737 173.673 41.8177Z"
					fill="#032B6B"
				/>
				<path
					d="M192.236 39.9531L195.385 52.6257L213.27 47.336"
					stroke="#032B6B"
					strokeWidth="1.44527"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M171.244 35.0947C167.691 35.9185 160.749 37.2626 160.123 35.8655C159.239 33.8879 171.764 28.6392 175.58 26.953C177.536 26.0979 184.304 24.2407 187.951 23.7108C192.709 23.0243 210.004 22.5859 212.4 38.0238L214.961 47.5698L197.95 52.6138"
					stroke="#032B6B"
					strokeWidth="1.44527"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M197.049 37.5155C195.033 38.8451 187.467 42.4246 183.668 42.333M177.316 29.7158C177.316 29.7158 169.155 35.2922 170.001 38.5561C170.846 41.82 173.4 40.724 173.4 40.724"
					stroke="#032B6B"
					strokeWidth="1.44527"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M179.438 33.0474C179.438 33.0474 172.595 38.6309 173.681 41.8177C174.768 45.0046 177.232 43.7183 177.232 43.7183"
					stroke="#032B6B"
					strokeWidth="1.44527"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M182.165 37.1108C182.165 37.1108 174.042 43.959 179.238 45.4067C184.434 46.8544 186.031 45.5825 186.031 45.5825C186.031 45.5825 187.731 42.692 182.379 42.2729"
					stroke="#032B6B"
					strokeWidth="1.44527"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M190.51 54.0132C193.928 58.5441 217.086 55.1309 220.897 49.2775C219.071 46.7724 217.616 48.2008 216.802 46.7218C214.863 43.1713 214.092 41.6128 214.092 41.6128C210.069 45.0212 203.76 45.6427 199.068 45.5463C196.999 45.5281 194.933 45.3728 192.885 45.0814C192.856 45.4403 192.757 46.8784 192.673 50.2362C192.632 52.1801 191.543 53.0304 190.51 54.0132Z"
					fill="#032B6B"
				/>
				<path
					d="M316.892 131.998H223.236C222.639 131.997 222.059 132.199 221.591 132.569C221.123 132.939 220.793 133.457 220.656 134.038L207.637 189.156H173.687C173.687 189.156 171.806 198.873 182.778 198.873H302.345C302.942 198.873 303.522 198.672 303.99 198.301C304.458 197.931 304.788 197.413 304.925 196.832L319.469 135.257C319.561 134.868 319.564 134.463 319.477 134.073C319.39 133.683 319.217 133.317 318.969 133.004C318.721 132.69 318.405 132.437 318.045 132.263C317.686 132.088 317.291 131.998 316.892 131.998Z"
					fill="#032B6B"
				/>
				<path
					d="M309.167 155.409C307.769 155.409 306.385 155.119 305.104 154.557C303.824 153.995 302.673 153.174 301.725 152.145C300.778 151.117 300.054 149.903 299.599 148.58C299.145 147.257 298.969 145.855 299.084 144.461C299.446 140.096 299.494 137.408 299.944 135.382C300.561 132.597 305.966 128.765 312.229 124.13C315.523 121.712 317.813 119.46 319.101 117.374C320.389 115.288 321.032 112.701 321.028 109.613C321.028 105.802 319.818 102.803 317.398 100.616C314.978 98.4288 312.048 97.3336 308.606 97.3304C301.77 97.3304 297.18 100.951 294.835 108.192C294.064 110.522 292.496 112.506 290.407 113.795C288.318 115.083 285.841 115.595 283.413 115.24C281.857 115.016 280.372 114.442 279.07 113.561C277.768 112.681 276.683 111.516 275.896 110.156C275.109 108.795 274.641 107.274 274.527 105.706C274.413 104.138 274.656 102.565 275.237 101.105C277.474 95.4459 280.681 90.8154 284.858 87.2135C291.781 81.2429 300.237 78.2568 310.227 78.2552C320.421 78.2552 328.968 81.1899 335.866 87.0593C342.765 92.9287 346.218 100.369 346.224 109.379C346.224 120.551 340.484 129.896 329.004 137.413C324.008 140.708 320.983 143.282 319.93 145.135C319.523 145.893 319.223 146.704 319.039 147.544C318.518 149.771 317.262 151.758 315.472 153.183C313.683 154.608 311.465 155.388 309.177 155.396L309.167 155.409ZM310.536 185.605H309.611C306.518 185.605 303.552 184.377 301.364 182.19C299.177 180.003 297.948 177.037 297.947 173.944C297.947 172.412 298.249 170.896 298.835 169.481C299.421 168.066 300.28 166.78 301.363 165.697C302.447 164.614 303.732 163.755 305.147 163.169C306.562 162.582 308.079 162.281 309.611 162.281H310.536C312.067 162.281 313.584 162.582 314.999 163.169C316.414 163.755 317.699 164.614 318.782 165.697C319.865 166.78 320.724 168.066 321.31 169.481C321.895 170.896 322.197 172.413 322.197 173.944C322.197 177.037 320.968 180.003 318.781 182.19C316.594 184.376 313.628 185.605 310.536 185.605ZM71.2713 56.7761C70.9604 56.9105 70.6251 56.9791 70.2864 56.9775C69.9477 56.9759 69.613 56.9042 69.3034 56.7668C68.9938 56.6295 68.7161 56.4294 68.4876 56.1794C68.2592 55.9293 68.085 55.6347 67.9761 55.314C67.7135 54.6266 67.486 53.9264 67.2944 53.2159C67.1643 52.5391 67.9929 51.1685 68.942 49.5353C69.3649 48.8726 69.6621 48.1377 69.8188 47.3674C69.8925 46.7135 69.7824 46.052 69.5008 45.4572C69.3583 45.0775 69.1346 44.7334 68.8455 44.4488C68.5564 44.1643 68.2087 43.9462 67.8267 43.8096C67.0833 43.556 66.2708 43.5982 65.5577 43.9277C64.0385 44.5861 63.3673 45.8322 63.5439 47.6661C63.5963 48.2575 63.4389 48.8485 63.0994 49.3356C62.7599 49.8227 62.2598 50.1748 61.6868 50.3302C61.3195 50.4302 60.9344 50.4456 60.5604 50.3752C60.1864 50.3049 59.8332 50.1507 59.5274 49.9241C59.2215 49.6976 58.9711 49.4047 58.7948 49.0674C58.6185 48.7301 58.521 48.3572 58.5096 47.9768C58.4437 46.5946 58.7184 45.2174 59.3093 43.9662C60.2728 41.9749 61.8634 40.4984 64.0811 39.5365C66.3453 38.5537 68.5261 38.3827 70.6233 39.0234C71.6161 39.3028 72.5323 39.8045 73.3023 40.4907C74.0723 41.1768 74.676 42.0293 75.0675 42.9834C76.1451 45.4645 75.7701 48.0925 73.9426 50.8674C73.1493 52.0798 72.7246 52.9421 72.6684 53.4544C72.6521 53.663 72.6643 53.8729 72.7045 54.0783C72.8036 54.623 72.716 55.1851 72.4559 55.6739C72.1958 56.1626 71.7784 56.5492 71.2713 56.7713V56.7761ZM74.4798 63.3497L74.2751 63.4388C73.935 63.5864 73.5692 63.6656 73.1986 63.6717C72.828 63.6779 72.4598 63.6109 72.115 63.4747C71.7703 63.3385 71.4558 63.1356 71.1895 62.8777C70.9232 62.6199 70.7104 62.312 70.5631 61.9719C70.2645 61.286 70.2506 60.5097 70.5243 59.8136C70.7981 59.1175 71.3371 58.5586 72.0228 58.2599L72.2276 58.1708C72.5676 58.0232 72.9334 57.944 73.304 57.9379C73.6747 57.9317 74.0429 57.9987 74.3876 58.1349C74.7323 58.2711 75.0469 58.474 75.3131 58.7319C75.5794 58.9897 75.7923 59.2976 75.9395 59.6377C76.2381 60.3236 76.2521 61.0999 75.9783 61.796C75.7046 62.4921 75.1656 63.051 74.4798 63.3497ZM84.086 25.9341C83.6243 25.9094 83.1727 25.7892 82.7598 25.581C82.347 25.3728 81.9818 25.0812 81.6875 24.7246C81.3931 24.368 81.176 23.9542 81.0499 23.5093C80.9237 23.0645 80.8913 22.5983 80.9546 22.1402C81.1545 20.707 81.2196 19.823 81.405 19.163C81.6459 18.2573 83.5055 17.0914 85.6614 15.6799C86.7855 14.9428 87.582 14.2418 88.0509 13.577C88.5399 12.8252 88.8094 11.9517 88.8289 11.055C88.898 9.79763 88.5535 8.78675 87.7955 8.02236C87.0427 7.25872 86.025 6.81372 84.9532 6.77943C82.705 6.65417 81.1264 7.76382 80.2175 10.1084C79.9202 10.8623 79.3669 11.4875 78.6546 11.8742C77.9424 12.2609 77.1168 12.3845 76.3225 12.2233C75.8126 12.1215 75.3324 11.9051 74.9184 11.5904C74.5044 11.2757 74.1674 10.8711 73.9328 10.407C73.6982 9.9429 73.5722 9.43155 73.5643 8.91159C73.5564 8.39164 73.6668 7.8767 73.8872 7.40571C74.6552 5.68202 75.8347 4.1733 77.3222 3.01209C79.7117 1.17499 82.5524 0.344768 85.8444 0.521412C89.2039 0.707691 91.9676 1.83179 94.1355 3.89371C96.3034 5.95562 97.3046 8.4712 97.1392 11.4404C96.9353 15.1226 94.8717 18.0967 90.9486 20.3626C89.2432 21.3598 88.1994 22.1531 87.8172 22.7424C87.67 22.987 87.5565 23.2503 87.48 23.5253C87.2675 24.2499 86.817 24.8818 86.2012 25.3189C85.5854 25.756 84.8402 25.9727 84.086 25.9341ZM83.9873 35.9064H83.6813C82.6621 35.8492 81.7072 35.39 81.0262 34.6295C80.3452 33.869 79.9937 32.8694 80.0489 31.85C80.0748 31.3437 80.2003 30.8474 80.4183 30.3897C80.6363 29.9319 80.9425 29.5217 81.3193 29.1824C81.6961 28.8432 82.1362 28.5817 82.6143 28.4128C83.0923 28.2439 83.599 28.171 84.1053 28.1983L84.4112 28.2152C84.9178 28.2435 85.4139 28.3715 85.8709 28.5919C86.3279 28.8124 86.7369 29.1209 87.0744 29.4998C87.4119 29.8787 87.6712 30.3205 87.8376 30.7999C88.0039 31.2792 88.0739 31.7867 88.0437 32.2932C87.9816 33.3091 87.5202 34.2591 86.7602 34.936C86.0003 35.6129 85.0035 35.9618 83.9873 35.9064Z"
					fill="#FFA108"
				/>
				<path
					d="M0.722656 199.234H365.277"
					stroke="#032B6B"
					strokeWidth="1.44527"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_265_637">
					<rect
						width="366"
						height="199.503"
						fill="white"
						transform="translate(0 0.497437)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default FaqSvg;
